export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
          📮 投稿爆料
        </h2>
        <p className="text-sm text-foreground-600 mb-8">
          您有猛料？欢迎向我们投稿！平台严格保护爆料人隐私信息
        </p>
        <div className="bg-background-100 border border-background-200/60 rounded-2xl p-8 text-left">
          <div className="space-y-5">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-mail-line text-primary-600 text-lg"></i>
              </div>
              <div>
                <div className="font-medium text-sm text-foreground-900 mb-1">爆料邮箱</div>
                <div className="text-sm text-foreground-600">tips@91heilia.com</div>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-shield-check-line text-accent-700 text-lg"></i>
              </div>
              <div>
                <div className="font-medium text-sm text-foreground-900 mb-1">隐私保护承诺</div>
                <div className="text-sm text-foreground-600 leading-relaxed">
                  所有爆料信息来源严格保密，绝不向第三方透露爆料人身份信息。对于重大独家爆料，我们提供行业内最高的线索奖励。
                </div>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-time-line text-secondary-700 text-lg"></i>
              </div>
              <div>
                <div className="font-medium text-sm text-foreground-900 mb-1">响应时效</div>
                <div className="text-sm text-foreground-600">
                  所有投稿将在24小时内完成审核与回复，紧急线索可标注"加急"优先处理。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}